(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/utils/edit-wager.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/utils/edit-wager.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function showPlayView(_ref) {
  let {
    playedWager,
    modelOptions,
    playViews,
    viewOptions,
    isProlongation
  } = _ref;
  renderPlayView({
    model: toPayableWager({
      playedWager,
      modelOptions,
      isProlongation
    }),
    playViews,
    viewOptions
  });
}

function renderPlayView(_ref2) {
  let {
    model,
    playViews,
    viewOptions
  } = _ref2;
  const rules = svs.numbergames.rules.getRules(model.get('productId'));
  let PlayView;
  let storageKey;
  let path;
  let size;
  if (model.get('isSystem')) {
    PlayView = playViews.System;
    storageKey = 'system';
    path = 'systemspel';
  } else if (model.get('isPackage') && model.get('boards').length > rules.maxNumberOfRows) {
    size = model.get('selectedPackage');
    PlayView = playViews.Package;
    storageKey = 'package';
    path = "fardiga-spel/".concat(size);
  } else {
    PlayView = playViews.Single;
    storageKey = 'single';
    path = '';
    if (svs.core.detect.formfactor.desktop()) {
      const {
        maxNumberOfRows
      } = svs.numbergames.game_model.rulesRadio.request('rules');
      model.get('boards').setLength(maxNumberOfRows);
    }
  }
  if (model.has('prolongedBet') && model.get('isSubscription')) {
    Backbone.history.navigate("/".concat(path).concat(Backbone.history.location.search));
    model.storageKey = storageKey;
    model.saveToLocalStorage();
  }
  svs.numbergames.game_app.app.updateItemsMenu(path);
  svs.numbergames.game_app.app.showView(new PlayView(_objectSpread({
    model,
    size
  }, viewOptions)));
  window.scrollTo(0, 0);
}

function toPayableWager(_ref3) {
  var _wager$originalNumDra;
  let {
    playedWager,
    modelOptions,
    isProlongation
  } = _ref3;
  let wager;
  if (playedWager instanceof Backbone.Model) {
    if (typeof playedWager.toObject !== 'function') {
      svs.numbergames.game.logger.debug('Incorrect model for wager. Expected mybets Wager or Subscription.');
      return;
    }
    wager = playedWager.toObject();
  } else {
    wager = playedWager;
  }
  const hasSubscriptionParam = svs.utils.paramHandler.get({
    key: 'dragningar'
  }).value === 'prenumerera';
  const bet = wager.bet;
  const drawCount = wager.isSubscription || hasSubscriptionParam ? 'subscription' : "".concat((_wager$originalNumDra = wager.originalNumDraws) !== null && _wager$originalNumDra !== void 0 ? _wager$originalNumDra : wager.totalDrawCount);
  const selectedPackage = getSelectedPackageSize(wager);
  const isPackage = Boolean(selectedPackage);
  const boards = bet.boards.map(mapBoard);
  const {
    isProductFamily,
    getProductItsId
  } = svs.numbergames.productMapping;
  const itsId = getProductItsId(wager.productName);
  let rowPriceMulti = 1;
  if (wager.hasLotto2) {
    rowPriceMulti = 2;
  }
  if (svs.numbergames.productMapping.isKeno(wager.productId)) {
    rowPriceMulti = bet.rowPriceMulti;
  }
  let selectedDays;
  if (isProductFamily(wager.productId)) {
    if (Array.isArray(wager.gameDays)) {
      selectedDays = wager.gameDays.map(day => getProductItsId(day));
    } else if (itsId) {
      selectedDays = [itsId];
    }
  }
  const jokerBet = wager.jokerBet;
  let jokerRow;
  let jokerPrice;
  let jokerItsId;
  if (jokerBet) {
    jokerItsId = svs.numbergames.productMapping.getJokerProductId(itsId);
    jokerRow = jokerBet.boards[0].numbers.map(num => ({
      number: num,
      manual: true
    }));
    jokerPrice = jokerBet.drawBetAmount;
  }
  let prolongedBet;
  if (isProlongation) {
    prolongedBet = {
      itsId,
      rowPriceMulti,
      boards,
      jokerRow,
      jokerPrice,
      jokerItsId,
      syndicateId: wager.syndicateId,
      wagerId: wager.wagerId
    };
    modelOptions = _objectSpread({
      storageKey: "prolong_".concat(wager.wagerId)
    }, modelOptions);
  }
  return new svs.numbergames.game_model.models.Wager({
    drawCount,
    rowPriceMulti,
    selectedDays,
    boards,
    jokerRow,
    jokerPrice,
    isPackage,
    prolongedBet,
    selectedPackage,
    isSystem: wager.isSystemWager,
    isSingle: wager.isSingleWager,
    productId: wager.productId,
    isSubscription: wager.isSubscription || hasSubscriptionParam,
    subscriptionId: wager.subscriptionId,
    syndicateId: hasSubscriptionParam ? 0 : wager.syndicateId
  }, _objectSpread({
    parse: true
  }, modelOptions));
}
function mapBoard(board) {
  const returnObj = {
    numbers: board.numbers.map(number => ({
      number,
      manual: true
    }))
  };
  if (Array.isArray(board.numbersExtra)) {
    returnObj.numbersExtra = board.numbersExtra.map(number => ({
      number,
      manual: true
    }));
  }
  if (svs.numbergames.productMapping.isKeno(board.productId)) {
    returnObj.level = Number(board.participation.match(/\d+/).join());
    returnObj.hasKungKeno = board.kungKeno;
  }
  return returnObj;
}
function getSelectedPackageSize(wager) {
  const calcWagerSize = () => wager.betAmount / wager.bet.rowPriceMulti / wager.totalDrawCount;
  const drawNumber = svs.numbergames.draws.drawsApi.drawNumber(wager.productName);
  const rules = svs.numbergames.rules.getRules(wager.productName, {
    product: wager.productName,
    drawNumber
  });
  let size;
  if (wager.isPackageWager && wager.subscriptionId) {
    size = wager.weeklyAmount / wager.drawsPerWeek;
  } else if (wager.isPackageWager && wager.bagType) {
    size = calcWagerSize();
  } else if (!wager.isSystemWager && wager.rowCount > rules.maxNumberOfRows) {
    if (wager.subscriptionId) {
      size = wager.weeklyAmount / wager.drawsPerWeek;
    } else {
      size = calcWagerSize();
    }
  }
  if (size) {
    if (rules.PACKAGES[size] && rules.PACKAGES[size].rows === wager.rowCount) {
      return size;
    }
    if (svs.numbergames.productMapping.isLotto(wager.productName)) {
      var _Object$entries$find;
      const [size] = (_Object$entries$find = Object.entries(rules.PACKAGES).find(_ref4 => {
        let [, packageConfig] = _ref4;
        return packageConfig.rows === wager.rowCount;
      })) !== null && _Object$entries$find !== void 0 ? _Object$entries$find : [];
      if (size) {
        return parseInt(size, 10);
      }
    }
    svs.numbergames.game.logger.info("Found ".concat(wager.productName, " wager with ").concat(wager.rowCount, " rows of unknown type when expecting package ").concat(size, "."));
  }
  return 0;
}
svs.numbergames.game.utils.editWager = {
  showPlayView,
  renderPlayView,
  toPayableWager
};

 })(window);